import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { signInPath } from '../utils/postAuthPath';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  
  // Loading state - don't redirect until we've checked authentication
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    // Redirect to sign-in, carrying where they were going
    return <Navigate replace to={signInPath(location.pathname, location.search)} />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;
